import React, { useState } from 'react';
import { Button, TextField, IconButton, Grid, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Delete, Add, Edit } from '@mui/icons-material';
import '../../../../styles/BurgerForm.scss';
import GenericFormGroup from './GenericFormGroup';

const BurgerFormGroup = ({ cantina, burgers, setBurgers }) => {
  const [newBurger, setNewBurger] = useState({ name: '', description: '', price: '' });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingBurgerIndex, setEditingBurgerIndex] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [burgerToDeleteIndex, setBurgerToDeleteIndex] = useState(null);
  const [selectedAllergens, setSelectedAllergens] = useState([]);
  const [allergensList] = useState(['Glutine', 'Uova', 'Arachidi', 'Lattosio', 'Crostacei', 'Pesce', 'Soia', 'Frutta a guscio', 'Sedano', 'Senape', 'Semi di sesamo', 'Anidride solforosa', 'Lupini', 'Molluschi']);

  const handleAllergensChange = (event) => {
    const { target: { value } } = event;
    setSelectedAllergens(typeof value === 'string' ? value.split(',') : value);
  };

  const handleDialogOpen = (burger = { name: '', description: '', price: '', allergens: [] }, index = null) => {
    setNewBurger(burger);
    setSelectedAllergens(burger.allergens || []);
    setEditingBurgerIndex(index);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setNewBurger({ name: '', description: '', price: '', allergens: [] });
    setEditingBurgerIndex(null);
    setDialogOpen(false);
  };

  const handleAddOrUpdateBurger = () => {
    if (editingBurgerIndex !== null) {
      const updatedBurgers = burgers.map((burger, index) => (index === editingBurgerIndex ? {...newBurger, allergens: selectedAllergens} : burger));
      setBurgers(updatedBurgers);
    } else {
      setBurgers([...burgers, newBurger]);
    }
    handleDialogClose();
  };

  const handleOpenConfirmDelete = (index) => {
    setBurgerToDeleteIndex(index);
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDeleteClose = () => {
    setBurgerToDeleteIndex(null);
    setConfirmDeleteOpen(false);
  };

  const handleDeleteBurger = () => {
    const updatedBurgers = burgers.filter((_, i) => i !== burgerToDeleteIndex);
    setBurgers(updatedBurgers);
    handleConfirmDeleteClose();
  };

  return (
    <div>
      <Typography variant="h6">Lista dei panini:</Typography>
      <Grid container spacing={2}>
        {burgers.map((burger, index) => (
          <Grid item xs={12} key={index}>
            <div className='burger-edit-item'>
              <Typography>{burger.name}</Typography>
              <div className='burger-edit-item'>
                <IconButton onClick={() => handleDialogOpen(burger, index)}>
                  <Edit />
                </IconButton>
                <IconButton onClick={() => handleOpenConfirmDelete(index)}>
                  <Delete />
                </IconButton>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
      <div className='add-btn-container'>
        <Button onClick={() => handleDialogOpen()} variant="contained" startIcon={<Add />} className='add-btn'>
          Aggiungi Panino
        </Button>
      </div>

      {/* Dialog per aggiungere/modificare il panino */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>{editingBurgerIndex !== null ? 'Modifica Panino' : 'Aggiungi Panino'}</DialogTitle>
        <DialogContent>
          <GenericFormGroup
                  newItem={newBurger}
                  setNewItem={setNewBurger}
                  allergensList={allergensList}
                  selectedAllergens={selectedAllergens}
                  handleAllergensChange={handleAllergensChange}
                  multiplePrices={false}
                />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddOrUpdateBurger} variant="contained">
            {editingBurgerIndex !== null ? 'Aggiorna' : 'Aggiungi'}
          </Button>
          <Button onClick={handleDialogClose} color="secondary">Annulla</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog di conferma per la cancellazione */}
      <Dialog open={confirmDeleteOpen} onClose={handleConfirmDeleteClose}>
        <DialogTitle>Conferma Eliminazione</DialogTitle>
        <DialogContent>
          <Typography>Sei sicuro di voler eliminare questo panino?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteBurger} color="error" variant="contained">
            Elimina
          </Button>
          <Button onClick={handleConfirmDeleteClose} color="secondary">Annulla</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BurgerFormGroup;
